var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRule = function SvgRule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.932 18.416l-5.971-5.812 2.378-2.315 3.577 3.48 7.152-6.96 2.379 2.314-9.515 9.293zm-9.345-6.567H3.404v3.283h15.183V11.85zm16.87 10.523l-2.38-2.315-4.369 4.253-4.369-4.253-2.378 2.315 4.369 4.252-4.37 4.253 2.38 2.314 4.368-4.252 4.37 4.252 2.378-2.314-4.369-4.253 4.37-4.252zm-16.87 2.61H3.404v3.284h15.183v-3.283z",
    fill: "#EEE",
    fillRule: "nonzero"
  }))));
};
export default SvgRule;